export const BRANCH_HAVE_NOTE_MASSAGE = [3, 4, 8, 15, 99]
export const VAT_DISCOUNT = {
    start: "2023-07-01",
    end: "2026-12-31",
    vatRate: 1.08
}